export default "__VITE_ASSET__7BxkD_sI__"